// config for the Discount V4 Test: https://gousto.atlassian.net/browse/BEET-731

export type SignupDiscount = {
  amount: number
  recurrence: number
}

export type BoxDiscounts = {
  [boxType: string]: SignupDiscount[]
}

// Recurrence is the number of orders that the discount applies to.
// Needs to add up to the total number of orders, which is calculated as
// ORDER_FREQUENCY multiplied by PROMOTION_DURATION.
const discountStagesBlackFriday: SignupDiscount[] = [
  { amount: 50, recurrence: 1 },
  { amount: 40, recurrence: 1 },
  { amount: 20, recurrence: 5 },
  { amount: 100, recurrence: 1 },
]

export const PROMOTION_DURATION = 2 // month
export const ORDER_FREQUENCY = 4 // orders per month

export const boxDiscounts: BoxDiscounts = {
  '2x1': discountStagesBlackFriday,
  '3x1': discountStagesBlackFriday,
  '4x1': discountStagesBlackFriday,
  '5x1': discountStagesBlackFriday,
  '2x2': discountStagesBlackFriday,
  '3x2': discountStagesBlackFriday,
  '4x2': discountStagesBlackFriday,
  '5x2': discountStagesBlackFriday,
  '2x3': discountStagesBlackFriday,
  '3x3': discountStagesBlackFriday,
  '4x3': discountStagesBlackFriday,
  '5x3': discountStagesBlackFriday,
  '2x4': discountStagesBlackFriday,
  '3x4': discountStagesBlackFriday,
  '4x4': discountStagesBlackFriday,
  '5x4': discountStagesBlackFriday,
  '2x5': discountStagesBlackFriday,
  '3x5': discountStagesBlackFriday,
}
